import React, { useState } from "react";
import { PlusSquare, Check, AlertCircle } from "lucide-react";

const CreateWidgetButton = ({ onCreateWidget, isCreating }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  
  const handleClick = async () => {
    try {
      await onCreateWidget();
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error("Widget creation error:", error);
      setShowError(true);
      setTimeout(() => setShowError(false), 3000);
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleClick}
        disabled={isCreating}
        aria-label="Create widget from conversation"
        className="flex items-center gap-1 text-white text-xs font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
        style={{
          padding: '4px 10px', borderRadius: '8px', border: 'none',
          background: 'rgba(255,255,255,0.2)',
          cursor: isCreating ? 'not-allowed' : 'pointer',
          opacity: isCreating ? 0.6 : 1,
        }}
        onMouseEnter={e => { if (!isCreating) e.currentTarget.style.background = 'rgba(255,255,255,0.3)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
      >
        {isCreating ? (
          <span className="flex items-center gap-1">
            <span className="animate-spin h-3 w-3 border border-white border-t-transparent rounded-full" />
            <span>Creating...</span>
          </span>
        ) : (
          <>
            <PlusSquare size={12} />
            <span>Widget</span>
          </>
        )}
      </button>

      {showSuccess && (
        <div className="absolute top-full mt-1.5 right-0 bg-green-100 text-green-800 px-2 py-1 rounded-lg text-xs flex items-center gap-1 whitespace-nowrap animate-fadeIn shadow-sm z-[9999]">
          <Check size={10} />
          Created!
        </div>
      )}

      {showError && (
        <div className="absolute top-full mt-1.5 right-0 bg-red-100 text-red-800 px-2 py-1 rounded-lg text-xs flex items-center gap-1 whitespace-nowrap animate-fadeIn shadow-sm z-[9999]">
          <AlertCircle size={10} />
          Failed
        </div>
      )}
    </div>
  );
};

export default CreateWidgetButton;